<template>
  <div>
    <div>
      <div class="vx-col w-full">
        <vx-card title="Showroom Footfall">
          <template slot="actions">
            <vs-button color="success" icon-pack="feather" icon="icon-plus" @click="addNewFootfall">Add New Footfall</vs-button>
          </template>
          <vs-tabs :color="colorx">
            <vs-tab @click="colorx = 'success'" label="Today's Footfall">
              <div class="con-tab-ejemplo">
                <TodayFootfall></TodayFootfall>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'success'" label="Next Seven Day's Footfall">
              <div class="con-tab-ejemplo">
                <NextSevenDaysFootfall></NextSevenDaysFootfall>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'success'" label="Next 30 Day's Footfall">
              <div class="con-tab-ejemplo">
                <NextOneMonthFootfall></NextOneMonthFootfall>
              </div>
            </vs-tab>
            <vs-tab @click="colorx = 'success'" label="Search Footfall">
              <div class="con-tab-ejemplo">
                <SearchFootfall></SearchFootfall>
              </div>
            </vs-tab>
          </vs-tabs>

        </vx-card>
      </div>
    </div>
    <!--<Guarantor></Guarantor>-->

  </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'
  import gql from 'graphql-tag'
  import TodayFootfall from './pages/TodayFootfall.vue'
  import NextSevenDaysFootfall from './pages/NextSevenDaysFootfall.vue'
  import NextOneMonthFootfall from './pages/NextOneMonthFootfall.vue'
  import SearchFootfall from './pages/SearchFootfall'

  export default {
    data () {
      return {
        footFallList: [],
        totalItems: 0,
        selected: [],
        fromDate:'',
        toDate:'',
        activeLoading: false,
        colorx:'success'
      }
    },
    apollo: {
      me: {
        query: gql`
        query me($created_at: DateRange, $first: Int!, $page: Int){
            me{
            id
            manager_name
            phone
            email
            address
            api_token
               footfalls(created_at: $created_at, first: $first, page: $page){
                paginatorInfo{
                  count
                  currentPage
                  firstItem
                  hasMorePages
                  lastItem
                  lastPage
                  perPage
                  total
                }
                data{
                  id
                  name
                  gender
                  email
                  mobile
                  sources
                  suffix
                  reason
                  product
                  brand
                  reminder_date
                  created_at
                  updated_at
                }
              }

           }
         }
        `,
        variables () {
          this.fromDate = moment(this.fromDate).format("yyyy-MM-DD");
          this.toDate = moment(this.toDate).format("yyyy-MM-DD");
          console.log("Date",this.fromDate );
          return {
            created_at:{
              from: this.fromDate === 'Invalid date'? "1901-01-01" : this.fromDate,
              to: this.toDate === 'Invalid date' ? "2099-01-01": this.toDate
            },
            first: 10,
            page: this.selectedPgae
          }
        },
        update: (data) => data.me
      }
    },
    watch: {
      me (value) {
        this.$apollo.queries.me.refetch()
        console.log('Me = ', value)
        this.footFallList = value.footfalls.data
        this.pagination = value.footfalls.paginatorInfo
        console.log('this.footFallList', this.footFallList)
        this.totalItems = this.pagination.total
        console.log('this.applicationList Length', this.totalItems)
      },
      '$apollo.loading': function (loading) {
        if (loading === true) {
          this.$vs.loading({
            type: 'sound'
          })
        } else {
          this.$vs.loading.close()
        }
      }
    },
    methods: {
      clearSearch(){
        this.fromDate = '';
        this.toDate = '';
      },
      customFormatter(fromDate, toDate) {
        if(fromDate)
          return moment(fromDate).format('yyyy-MM-DD');
        else
          return moment(toDate).format('yyyy-MM-DD');
      },
      searchByDate(){

      },
      addNewFootfall () {
        this.$router.push('/new_footfall').catch(() => {
        })
      },
      hire () {
        this.$router.push('/hire_agreement').catch(() => {
        })
      },
      footFallDetal (id) {
        this.$router.push('/footfallDetails/' + id).catch(() => {
        })
      },
      updateFootFall (id) {
        this.$router.push('/updateFootfall/' + id).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      }

    },
    components: {
      Datepicker,
      TodayFootfall,
      NextSevenDaysFootfall,
      NextOneMonthFootfall,
      SearchFootfall
    }
  }
</script>
